import { render } from "./podCtrn.vue?vue&type=template&id=dc6d51e6"
import script from "./podCtrn.vue?vue&type=script&lang=js"
export * from "./podCtrn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__